/**
 * PORTED — RO-3-00 / #44398.
 * Origin: `excellent/app/projects/[projectSlug]/[sectionSlug]/_agents/role-select.tsx`
 * (verbatim, minus the inert `"use client"`).
 *
 * ⚠️ `<SelectValue>` is load-bearing, not decoration: without it a Radix picker
 * opens off-screen in this app. Do not "simplify" it away.
 */

import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@excellent/ui";

export interface RoleOption {
  name: string;
  description: string;
}

/** Role picker for the operations-section new-goal form. Copy of the
 *  standalone `/goals/new` island so the section owns its own component
 *  after the standalone route is retired. */
export function RoleSelect({
  roles,
  defaultRole,
}: {
  roles: RoleOption[];
  defaultRole: string;
}) {
  return (
    <Select name="role" defaultValue={defaultRole}>
      <SelectTrigger className="mt-2 w-full">
        <SelectValue placeholder="Pick a role" />
      </SelectTrigger>
      <SelectContent>
        {roles.map((r) => (
          <SelectItem key={r.name} value={r.name}>
            {r.name} — {r.description.slice(0, 80)}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
